import { useEffect, useState } from 'react';

import { timeFormat } from 'app/utils/formatSecondsToTime';
import { useInterval } from 'app/hooks';

interface TimeRemainingProps {
  seconds: number;
  playing: boolean;
}

const TimeRemaining = ({ seconds, playing }: TimeRemainingProps) => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useInterval(
    () => {
      setTimeRemaining(timeRemaining - 1);
    },

    timeRemaining ? (playing ? 1000 : null) : null
  );

  useEffect(() => {
    setTimeRemaining(seconds || 0);
  }, [seconds]);

  return <>{timeRemaining ? timeFormat(timeRemaining || 0) : timeFormat(0)}</>;
};

export default TimeRemaining;
